import { useMutation, type MutationFunction } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useProvider } from 'utils/providers/Provider';

export default function useResendOtp() {
  const { state } = useProvider();
  const args = state;

  const mutationFn: MutationFunction<any, any> = async (id: string) => {
    const api = new Api(args);

    const data = await api.post({
      url: 'api/v3/auth/accounts/otp/resend-verification',
      payload: { id },
    });

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      toastSuccess('Successfully resent new email verification');
    },
  });
}
